(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom_price-filter"] && !Shopify.designMode) return;
  try {
    (() => {
    const parseAmount = (value) => {
      if (value == null || String(value).trim() === '') return null;
      const normalized = String(value).replace(/[^\d.,]/g, '').replace(',', '.');
      const parsed = Number.parseFloat(normalized);
      return Number.isFinite(parsed) ? parsed : null;
    };

    const syncRangeFill = (root, max) => {
      const minRange = root.querySelector('[data-mox-price-range-min]');
      const maxRange = root.querySelector('[data-mox-price-range-max]');
      if (!(minRange instanceof HTMLInputElement) || !(maxRange instanceof HTMLInputElement) || max <= 0) return;

      const minVal = Number.parseFloat(minRange.value);
      const maxVal = Number.parseFloat(maxRange.value);
      const minRatio = Math.min(Math.max(minVal / max, 0), 1);
      const maxRatio = Math.min(Math.max(maxVal / max, 0), 1);
      root.style.setProperty('--mox-price-range-min-ratio', String(minRatio));
      root.style.setProperty('--mox-price-range-max-ratio', String(maxRatio));
    };

    const syncPresetsFromInputs = (facet) => {
      const { minInput, maxInput } = facet.refs ?? {};
      if (!minInput || !maxInput) return;

      const minVal = parseAmount(minInput.value);
      const maxVal = parseAmount(maxInput.value);

      for (const preset of facet.querySelectorAll('[data-mox-price-preset]')) {
        if (!(preset instanceof HTMLElement)) continue;

        const presetMin = preset.dataset.min === '' ? null : Number.parseFloat(preset.dataset.min || '0');
        const presetMax = preset.dataset.max === '' ? null : Number.parseFloat(preset.dataset.max || '0');

        const isMatch =
          (presetMin == null && presetMax != null && minVal == null && maxVal === presetMax) ||
          (presetMin != null && presetMax != null && minVal === presetMin && maxVal === presetMax) ||
          (presetMin != null && presetMax == null && minVal === presetMin && maxVal == null);

        preset.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
      }
    };

    const syncRangeFromInputs = (facet) => {
      const max = Number.parseFloat(facet.dataset.rangeMax || '0');
      const rangeWrap = facet.querySelector('[data-mox-plp-price-range]');
      const minRange = facet.querySelector('[data-mox-price-range-min]');
      const maxRange = facet.querySelector('[data-mox-price-range-max]');
      const { minInput, maxInput } = facet.refs ?? {};

      if (
        !(rangeWrap instanceof HTMLElement) ||
        !(minRange instanceof HTMLInputElement) ||
        !(maxRange instanceof HTMLInputElement) ||
        !minInput ||
        !maxInput ||
        max <= 0
      ) {
        return;
      }

      const minVal = parseAmount(minInput.value) ?? 0;
      const maxVal = parseAmount(maxInput.value) ?? max;
      minRange.value = String(Math.min(minVal, max));
      maxRange.value = String(Math.max(maxVal, minVal));
      syncRangeFill(rangeWrap, max);
      syncPresetsFromInputs(facet);
    };

    const applyRange = (facet, min, max) => {
      const { minInput, maxInput } = facet.refs ?? {};
      if (!minInput || !maxInput) return;

      // Horizon reescribe data-min/data-max con el rango previo; sin resetear,
      // #adjustToValidValues recorta el rango nuevo al viejo.
      const rangeMax = facet.dataset.rangeMax || '';
      for (const input of [minInput, maxInput]) {
        input.setAttribute('data-min', '0');
        input.setAttribute('data-max', rangeMax);
      }

      minInput.value = min;
      maxInput.value = max;

      if (typeof facet.updatePriceFilterAndResults === 'function') {
        facet.updatePriceFilterAndResults();
      } else {
        minInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      syncRangeFromInputs(facet);
    };

    const initFacet = (facet) => {
      if (!(facet instanceof HTMLElement) || facet.dataset.moxPlpPriceReady === 'true') return;
      facet.dataset.moxPlpPriceReady = 'true';
      syncRangeFromInputs(facet);
    };

    const initAll = () => {
      for (const facet of document.querySelectorAll('.mox-plp-price-facet')) {
        initFacet(facet);
      }
    };

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const preset = target.closest('[data-mox-price-preset]');
      if (!(preset instanceof HTMLElement)) return;

      const facet = preset.closest('.mox-plp-price-facet');
      if (!(facet instanceof HTMLElement)) return;

      const wasPressed = preset.getAttribute('aria-pressed') === 'true';

      if (wasPressed) {
        applyRange(facet, '', '');
      } else {
        applyRange(facet, preset.dataset.min || '', preset.dataset.max || '');
      }
    });

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;

      const facet = target.closest('.mox-plp-price-facet');
      if (!facet || !(target.matches('[data-mox-price-range-min]') || target.matches('[data-mox-price-range-max]'))) {
        if (facet && (target === facet.refs?.minInput || target === facet.refs?.maxInput)) {
          syncRangeFromInputs(facet);
        }
        return;
      }

      const minRange = facet.querySelector('[data-mox-price-range-min]');
      const maxRange = facet.querySelector('[data-mox-price-range-max]');
      const { minInput, maxInput } = facet.refs ?? {};
      const max = Number.parseFloat(facet.dataset.rangeMax || '0');

      if (
        !(minRange instanceof HTMLInputElement) ||
        !(maxRange instanceof HTMLInputElement) ||
        !minInput ||
        !maxInput ||
        max <= 0
      ) {
        return;
      }

      let minVal = Number.parseFloat(minRange.value);
      let maxVal = Number.parseFloat(maxRange.value);

      if (minVal > maxVal) {
        if (target === minRange) maxVal = minVal;
        else minVal = maxVal;
        minRange.value = String(minVal);
        maxRange.value = String(maxVal);
      }

      minInput.value = minVal <= 0 ? '' : String(minVal);
      maxInput.value = maxVal >= max ? '' : String(maxVal);

      if (typeof facet.updatePriceFilterAndResults === 'function') {
        facet.updatePriceFilterAndResults();
      }

      syncRangeFromInputs(facet);
    });

    document.addEventListener('shopify:collection:update', (event) => {
      const promise = event.detail?.promise;
      if (promise && typeof promise.then === 'function') {
        promise.then(initAll);
      } else {
        initAll();
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
